import { useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import { SpaEntityWithTimeslots } from 'shared-types/Spa';
import { getWeeklyTimeslots } from '../utils/getWeeklyTimeslots';
import { SPA_TIMESLOT_AVAILABILITY_TIMEOUT } from './consts';

const getSpaTreatmentWithTimeslots = async (
  propertyId: number,
  language: string,
  spaTreatmentId: number,
  arrivalDate: string,
  detail?: boolean
) => {
  const { data } = await request.get(`${propertyId}/spa-treatments/${spaTreatmentId}/${language}`, {
    params: {
      arrivalDate,
      isTimeSlot: detail ? 1 : 0,
    },
    timeout: SPA_TIMESLOT_AVAILABILITY_TIMEOUT,
  });
  return data as SpaEntityWithTimeslots;
};

export function useGetSpaTreatmentTimeslots(
  propertyId: number,
  spaTreatmentId: number,
  startDate: string,
  language: string,
  detail?: boolean,
  enabled = true,
  numberOfDays = 7,
  numberOfGuests = 1
) {
  return useQuery({
    queryKey: getSpaTreatmentTimeslotsKey(
      propertyId,
      spaTreatmentId,
      startDate,
      language,
      !!detail,
      numberOfDays,
      numberOfGuests
    ),
    queryFn: () =>
      getSpaTreatmentTimeslots({
        spaTreatmentId,
        startDate,
        language,
        propertyId,
        detail,
        numberOfDays,
      }),
    enabled,
    staleTime: 0,
    cacheTime: 0,
  });
}

export async function getSpaTreatmentTimeslots({
  spaTreatmentId,
  startDate,
  language,
  propertyId,
  detail = false,
  numberOfDays = 7,
}: {
  spaTreatmentId: number;
  startDate: string;
  language: string;
  propertyId: number;
  detail?: boolean;
  numberOfDays?: number;
}) {
  const getTimeslots = (arrivalDate: string) =>
    getSpaTreatmentWithTimeslots(propertyId, language, spaTreatmentId, arrivalDate, detail);

  return getWeeklyTimeslots(getTimeslots, startDate, numberOfDays);
}

export const getSpaTreatmentTimeslotsKey = (
  propertyId: number,
  spaTreatmentId: number,
  startDate: string,
  language: string,
  detail: boolean,
  numberOfDays: number,
  numberOfGuests: number
) => [
  'spaTreatment',
  'timeslots',
  language,
  propertyId,
  spaTreatmentId,
  startDate,
  detail,
  numberOfDays,
  numberOfGuests,
];
